<template>
  <div :class="device.desktop ? `kw pa-6` : `kw pa-2`">
    <div class="kw-panel">
      <div class="kw-panel-header">
        <v-icon
          small
          color="#60a5fa"
          class="mr-2"
        >mdi-map-legend</v-icon>
        <span class="kw-panel-title">DAFTAR KATEGORI WILAYAH</span>
        <span class="kw-panel-count">{{ records.length }} kategori</span>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Cari kategori..."
          single-line
          hide-details
          solo
          flat
          dense
          dark
          background-color="#0a1224"
          color="#60a5fa"
          class="kw-search"
          style="max-width: 300px"
        ></v-text-field>
        <v-tooltip
          bottom
          color="#1e2c4f"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              dark
              v-on="on"
              v-show="page.actions.refresh"
              @click="fetchRecords"
              class="ml-2"
            >
              <v-icon color="#94a3b8">mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>Refresh Data</span>
        </v-tooltip>
        <v-btn
          depressed
          dark
          small
          class="kw-btn-add ml-2"
          v-show="page.actions.add"
          @click="openForm"
        >
          <v-icon
            left
            small
          >mdi-plus-circle-outline</v-icon>
          Tambah
        </v-btn>
      </div>

      <v-data-table
        v-show="device.desktop"
        :headers="headers"
        :items="records"
        :items-per-page="table.options.itemsPerPage"
        :page.sync="table.options.page"
        class="kw-table"
        dark
        :loading="loading.table"
        loading-text="Memuat data kategori wilayah..."
        :search="search"
        hide-default-footer
        @page-count="table.options.pageCount = $event"
      >
        <v-progress-linear
          slot="progress"
          color="#3b82f6"
          height="2"
          indeterminate
        ></v-progress-linear>

        <template v-slot:item.name="{ value }">
          <div class="kw-name">
            <v-icon
              small
              color="#60a5fa"
              class="mr-2"
            >mdi-tag-outline</v-icon>
            {{ value }}
          </div>
        </template>

        <template v-slot:item.id="{ value }">
          <v-menu
            bottom
            origin="center center"
            transition="scale-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="#60a5fa"
                v-bind="attrs"
                v-on="on"
              >
                mdi-dots-vertical-circle-outline
              </v-icon>
            </template>

            <v-list
              dark
              color="#101b36"
            >
              <v-list-item
                @click="editRecord(value)"
                v-show="page.actions.edit"
              >
                <v-list-item-title>
                  <v-icon
                    color="orange"
                    class="mr-1"
                  >mdi-pencil-circle</v-icon>Ubah Data
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="postDeleteRecord(value)"
                v-show="page.actions.delete"
              >
                <v-list-item-title>
                  <v-icon
                    class="mr-1"
                    color="red"
                  >mdi-delete-circle</v-icon>Hapus
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>

      <v-list
        subheader
        three-line
        v-show="device.mobile"
        dark
        color="#101b36"
      >
        <v-list-item
          v-for="item in filterItems"
          :key="item.id"
        >
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ item.description }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-menu
              bottom
              origin="center center"
              transition="scale-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="#60a5fa"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-dots-vertical-circle-outline
                </v-icon>
              </template>
              <v-list
                dark
                color="#101b36"
              >
                <v-list-item
                  @click="editRecord(item.id)"
                  v-show="page.actions.edit"
                >
                  <v-list-item-title>
                    <v-icon color="orange">mdi-pencil-circle</v-icon>
                    Ubah Data
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="postDeleteRecord(item.id)"
                  v-show="page.actions.delete"
                >
                  <v-list-item-title>
                    <v-icon color="red">mdi-delete-circle</v-icon>
                    Hapus Data
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </div>

    <v-dialog
      transition="dialog-bottom-transition"
      v-model="form.add"
      :max-width="device.desktop ? `600px` : `100%`"
      persistent
      :fullscreen="device.mobile"
    >
      <v-card
        color="#101b36"
        dark
        class="kw-dialog"
      >
        <div class="kw-dialog-header">
          <v-icon
            small
            color="#60a5fa"
            class="mr-2"
          >{{ form.edit ? `mdi-pencil-circle-outline` : `mdi-plus-circle-outline` }}</v-icon>
          <span class="kw-panel-title">{{ form.edit ? `UBAH KATEGORI WILAYAH` : `TAMBAH KATEGORI WILAYAH` }}</span>
        </div>
        <v-card-text class="mt-4">
          <v-col cols="12">
            <v-text-field
              outlined
              dark
              color="#60a5fa"
              background-color="#0a1224"
              label="Kategori Wilayah"
              placeholder="Contoh: Perkotaan / Pedesaan"
              persistent-hint
              hint="Nama kategori pengelompokan wilayah CCTV"
              v-model="record.name"
              dense
              prepend-inner-icon="mdi-tag-outline"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea
              label="Keterangan"
              dark
              color="#60a5fa"
              background-color="#0a1224"
              v-model="record.description"
              outlined
              dense
              persistent-hint
              hint="Penjelasan singkat kategori ini"
              rows="3"
              prepend-inner-icon="mdi-text-box-outline"
            ></v-textarea>
          </v-col>
        </v-card-text>
        <v-divider class="kw-dialog-divider"></v-divider>
        <v-card-actions class="justify-end pa-4">
          <v-btn
            text
            color="#94a3b8"
            @click="closeForm"
          >Batal</v-btn>
          <v-btn
            depressed
            dark
            class="kw-btn-add"
            v-show="!form.edit"
            @click="postAddNewRecord"
          >
            <v-icon
              left
              small
            >mdi-content-save-outline</v-icon>
            Tambah
          </v-btn>
          <v-btn
            depressed
            dark
            class="kw-btn-add"
            v-show="form.edit"
            @click="postUpdateRecord"
          >
            <v-icon
              left
              small
            >mdi-content-save-outline</v-icon>
            Ubah
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "master-kategori-wilayah",
  data: () => ({
    search: null,
    headers: [
      {
        text: "NAMA",
        align: "start",
        sortable: true,
        value: "name",
      },
      {
        text: "KETERANGAN",
        value: "description",
        sortable: false,
      },
      {
        text: "AKSI",
        value: "id",
        width: 80,
        sortable: false,
        align: "center",
      },
    ],
  }),
  computed: {
    ...mapState([
      "page",
      "theme",
      "http",
      "device",
      "record",
      "records",
      "loading",
      "form",
      "table",
    ]),
    filterItems() {
      if (!this.search) return this.records;
      const q = this.search.toLowerCase();
      return this.records.filter((item) => {
        return (
          String(item.name || "")
            .toLowerCase()
            .indexOf(q) > -1 ||
          String(item.description || "")
            .toLowerCase()
            .indexOf(q) > -1
        );
      });
    },
  },
  created() {
    this.setPage({
      crud: true,
      dataUrl: "api/superadmin/master-data/kategori-wilayahs",
      pagination: false,
      title: "MASTER KATEGORI WILAYAH",
      subtitle: "Berikut Daftar Kategori Wilayah CCTV",
      showtable: true,
      breadcrumbs: [
        { text: "Data Master", disabled: true, href: "" },
        { text: "Kategori Wilayah", disabled: false, href: "" },
      ],
      actions: {
        refresh: true,
        add: true,
        edit: true,
        delete: true,
        bulkdelete: false,
        print: false,
        export: false,
        help: false,
      },
    });
    this.fetchRecords();
  },
  methods: {
    ...mapActions([
      "setPage",
      "fetchRecords",
      "postAddNew",
      "postEdit",
      "postUpdate",
      "postConfirmDelete",
      "setRecord",
      "setForm",
    ]),
    openForm() {
      this.setForm({ add: true, edit: false });
      this.setRecord({});
    },
    closeForm() {
      this.setForm({ add: false, edit: false });
    },
    postAddNewRecord() {
      this.postAddNew(this.record).then(() => {
        this.closeForm();
      });
    },
    editRecord(val) {
      this.postEdit(val);
      this.setForm({ add: true, edit: true });
    },
    postUpdateRecord() {
      this.postUpdate(this.record).then(() => {
        this.closeForm();
      });
    },
    postDeleteRecord(val) {
      this.postConfirmDelete(val);
    },
  },
};
</script>

<style scoped>
.kw {
  min-height: 100%;
  background: #0a1224;
}

.kw-panel {
  background: #101b36;
  border: 1px solid #1e2c4f;
  border-radius: 12px;
  overflow: hidden;
}

.kw-panel-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #1e2c4f;
}

.kw-panel-title {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.8px;
  color: #e2e8f0;
}

.kw-panel-count {
  margin-left: 10px;
  padding: 2px 10px;
  border-radius: 999px;
  background: #0a1224;
  border: 1px solid #1e2c4f;
  font-size: 10px;
  font-weight: 600;
  color: #93c5fd;
}

.kw-search >>> .v-input__slot {
  border: 1px solid #1e2c4f;
  border-radius: 8px;
}

.kw-btn-add {
  border-radius: 8px;
  font-weight: 700;
  letter-spacing: 0.5px;
  background: linear-gradient(135deg, #1d4ed8 0%, #0b3a79 100%) !important;
}

.kw-table {
  background: #101b36 !important;
}

.kw-table >>> thead th {
  background: #0d1730 !important;
  color: #93c5fd !important;
  font-size: 11px !important;
  letter-spacing: 0.5px;
  border-bottom: 1px solid #1e2c4f !important;
}

.kw-table >>> tbody td {
  color: #cbd5e1 !important;
  font-size: 13px !important;
  border-bottom: 1px solid #16224384 !important;
}

.kw-table >>> tbody tr:hover {
  background: #16224384 !important;
}

.kw-name {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #e2e8f0;
}

.kw-dialog {
  border: 1px solid #1e2c4f;
}

.kw-dialog-header {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid #1e2c4f;
  background: #0d1730;
}

.kw-dialog-divider {
  border-color: #1e2c4f !important;
}
</style>
